import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import { findIndex as _findIndex } from 'lodash';

import { isPluginActive } from 'helpers/whiteLabel';

import Data from 'components/Data';
import List from 'components/List';

class DashboardInitSepaAgreement extends React.Component {
  // check if current user's company has bank data
  hasBankData = () => {
    const { myParent } = this.props;

    if (!myParent.pending && myParent.data.financial && myParent.data.financial.bank_data) {
      const bankData = myParent.data.financial.bank_data;

      if (bankData.iban && bankData.swift_bic) {
        return true;
      }
    }

    return false;
  };

  getMissingSepaPluginId = () => {
    const { sepaAgreements, plugins, projectConfig } = this.props;
    let missingSepaPluginId = null;

    if (!sepaAgreements.pending && !plugins.pending) {
      for (let i = 0; i < plugins.data.list.length; i++) {
        // loop through available plugins and check if they're active
        if (isPluginActive(plugins.data.list[i].id, projectConfig.data)) {
          if (_findIndex(sepaAgreements.data.list, { is_active: true, target: plugins.data.list[i].owner.id }) === -1) {
            missingSepaPluginId = plugins.data.list[i].id;
            break;
          }
        }
      }
    }

    return missingSepaPluginId;
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      plugins,
      myParent,
    } = this.props;

    const hasBankData = this.hasBankData();
    const missingSepaPluginId = hasBankData ? this.getMissingSepaPluginId() : null;

    return (
      <div>
        <Data dataName="myParent" url="/api/clients/parent.json" data={myParent} />
        <List noRender listName="whiteLabelPlugin" url="/api/whitelabelplugins.json" list={plugins} />

        {plugins.pending || myParent.pending ? null : (
          <div>
            {!hasBankData ? (
              <div class="jumbotron">
                <Grid fluid class="m-b-20 m-t-20">
                  <Row>
                    <Col lg={6} lgOffset={6}>
                      <div class="card card-transparent">
                        <div class="card-header">
                          <div class="card-title">{messages.missing_bank_data}</div>
                        </div>
                        <div class="card-block">
                          <h3>{messages.we_dont_have_your_bank_data}</h3>
                          <p>{messages.monthly_billing_relies_on_sepa_direct_debit_fill_in_bank_data_in_settings}</p>
                          <div class="text-right p-t-15">
                            <Button
                              bsStyle="primary"
                              onClick={() => this.props.history.push(appIntl.urlPrefix + 'account/settings/myCompany')}
                            >
                              {' '}
                              {messages.fill_in_bank_data}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Grid>
              </div>
            ) : null}

            {hasBankData && missingSepaPluginId ? (
              <div class="jumbotron">
                <Grid fluid class="m-b-20 m-t-20">
                  <Row>
                    <Col lg={6} class=""></Col>
                    <Col lg={6}>
                      <div class="card card-transparent">
                        <div class="card-header">
                          <div class="card-title">{messages.sepa_mandate}</div>
                        </div>
                        <div class="card-block">
                          <h3>{messages.missing_sepa_mandate}</h3>
                          <p>{messages.changed_bank_data_please_generate_new_sepa_mandate}</p>
                          <div class="text-right p-t-15">
                            <Button
                              bsStyle="primary"
                              onClick={() =>
                                this.props.history.push(
                                  appIntl.urlPrefix + 'account/settings/plugins/' + missingSepaPluginId + '/sepa'
                                )
                              }
                            >
                              {' '}
                              {messages.generate_sepa_mandate_now}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Grid>
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    myParent: state.data.myParent,
    plugins: state.list.whiteLabelPlugin,
    projectConfig: state.data.projectConfig,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(DashboardInitSepaAgreement)));
